<template>

    <div>
        <div class="modal fade" style="display: block; opacity: 1;" tabindex="-1" id="modalAddVehicle">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <button type="button" @click="closeModal" class="close" data-dismiss="modal" aria-label="Close">
                    <em class="icon ni ni-cross"></em>
                </button>
                <div class="modal-header">
                    <h5 class="modal-title">{{ translations.forms.vehicle.title_create }}</h5>
                </div>
                <div class="modal-body">

                    <div id="form-edit-competitor">

                        <div class="form-group row">
                            <div class="col">
                                <label for="brand">{{ translations.forms.vehicle.brand }}*</label>
                                <input id="brand" v-model="brand" type="text" required="required" class="form-control">
                            </div>
                            <div class="col">
                                <label for="type">{{ translations.forms.vehicle.type }}*</label>
                                <input id="type" v-model="type" type="text" required="required" class="form-control">
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <label for="build_year">{{ translations.forms.vehicle.build_year }}*</label>
                                <input id="build_year" v-model="build_year" type="number" required="required" class="form-control">
                            </div>
                            <div class="col">
                                <label for="chassis_number">{{ translations.forms.vehicle.chassis_number }}*</label>
                                <input id="chassis_number" v-model="chassis_number" type="text" required="required" class="form-control">
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <label for="license_plate">{{ translations.forms.vehicle.license_plate }}*</label>
                                <input id="license_plate" v-model="license_plate" type="text" required="required" class="form-control">
                            </div>
                        </div>

                    </div>

                </div>
                <div class="modal-footer bg-light">
                    <button type="button" @click="saveVehicle" class="btn btn-success">{{ translations.forms.competitor.save }}</button>
                </div>
            </div>
        </div>
    </div>
        <div class="modal-backdrop fade show"></div>
    </div>

</template>

<script>
    export default {
        name: 'addVehicleModal',
        props: [
            'translations',
        ],

        data() {
            return {
                brand: '',
                type: '',
                build_year: '',
                chassis_number: '',
                license_plate: '',
            }
        },

        mounted() {
            this.vehicleInfo = this.vehicle;
        },

        methods: {
            saveVehicle() {
                // do api call to the server so the competitor gets created
                axios.post('/api/internal/events/registration/create-vehicle', {
                    user_id: parseInt(USER_ID),
                    brand: this.brand,
                    type: this.type,
                    build_year: this.build_year,
                    chassis_number: this.chassis_number,
                    license_plate: this.license_plate,
                }).then((response) => {

                    this.$emit('onSave', response.data.vehicle);

                    NioApp.Toast(response.data.message, 'success', {position: 'top-right', timeOut: 5000});
                }).catch((errors) => {
                    console.log(errors);
                });
            },
            closeModal() {
                this.$emit('closeModal');
            }
        }
    }
</script>
